import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FaCreditCard,
  FaMoneyCheckAlt,
  FaUserCog,
  FaBalanceScale,
  FaSignOutAlt,
  FaBuilding,
  FaMapMarkedAlt,
  FaMoneyBillAlt ,
  FaCoins ,
  FaShoppingBag 
} from 'react-icons/fa';
import './Profile.css';
import { logout, fetchUserProfile } from '../../store/reducers/authReducer';
import { useAppDispatch, useAppSelector } from '../../store/hooks';

const Profile: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { profile, isFetchingProfile, profileError } =
    useAppSelector(state => state.auth);

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  let balanceDisplay = '$0.00';
  if (isFetchingProfile) balanceDisplay = 'Loading…';
  else if (profileError) balanceDisplay = 'Error';
  else if (profile)
    balanceDisplay = `$${profile.totalPropertyPrice.toFixed(2)}`;

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  const handleAssetsClick = () => {
    navigate('/assets');
  };

  const handleMapClick = () => {
    navigate('/cesium-maps_wew_without_data_with_popup.html');
  };

  return (
    <div className="profile-container">
      <header className="profile-header">
        <FaMapMarkedAlt
          className="map-icon"
          onClick={handleMapClick}
        />

        <h1>Profile</h1>

        <div className="profile-balance">
          <span className="balance-text">{balanceDisplay}</span>
        </div>
      </header>

      <ul className="profile-list">
        <li className="profile-item" onClick={handleAssetsClick}>
          <div className="icon-circle"><FaBuilding /></div>
          <span className="item-label">My Property List</span>
        </li>
        <li className="profile-item" onClick={() => navigate('/payment-methods')}>
          <div className="icon-circle"><FaCreditCard /></div>
          <span className="item-label">Payment Methods</span>
        </li>
        <li className="profile-item" onClick={() => navigate('/withdrawal-methods')}>
          <div className="icon-circle"><FaMoneyCheckAlt /></div>
          <span className="item-label">Withdrawal Methods</span>
        </li>
          <li className="profile-item" onClick={() => navigate('/Withdrawl')}>
          <div className="icon-circle"><FaCoins /></div>
          <span className="item-label">Withdrawal</span>
        </li>
        <li className="profile-item" onClick={() => navigate('/shop')}>
          <div className="icon-circle"><FaShoppingBag  /></div>
          <span className="item-label">Shop</span>
        </li>
        <li className="profile-item" onClick={() => navigate('/bids')}>
          <div className="icon-circle"><FaMoneyBillAlt />
          </div>
          <span className="item-label">My Bids</span>
        </li>
        <li className="profile-item" onClick={() => navigate('/Account-settings')}>
          <div className="icon-circle"><FaUserCog /></div>
          <span className="item-label">Account Settings</span>
        </li>
        <li className="profile-item" onClick={() => navigate('/legal')}>
          <div className="icon-circle"><FaBalanceScale /></div>
          <span className="item-label">Legal Terms</span>
        </li>
      </ul>

      <div className="logout-section" onClick={handleLogout}>
        <FaSignOutAlt className="logout-icon" />
        <span className="logout-text">Logout</span>
      </div>
    </div>
  );
};

export default Profile;
